import { h, Host } from "@stencil/core";
export class Eyecatcher {
    constructor() {
        this.variant = undefined;
    }
    render() {
        return (h(Host, { key: 'b1a4d9186cb49ce2c874faf429d4085b53ff3602', variant: this.variant }, h("slot", { key: 'bfc4276a0b2bb24cccd9554b9aa55a4e944560e9' })));
    }
    static get is() { return "ux-eyecatcher"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["eyecatcher.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["eyecatcher.css"]
        };
    }
    static get properties() {
        return {
            "variant": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"blue\" | \"bold\" | \"round\" | \"plain\"",
                    "resolved": "\"blue\" | \"bold\" | \"plain\" | \"round\"",
                    "references": {}
                },
                "required": true,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The variant of the eyecatcher."
                },
                "attribute": "variant",
                "reflect": false
            }
        };
    }
}
//# sourceMappingURL=eyecatcher.js.map
